/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "37a9d90c33262d11ee4842f2f328a0b7f915e6f0";
